import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router';

import { Button, Card, Page, Inline, Input, Box, Text, u, Heading2, Stack } from '@ui';

import { useBoothUserConfirmEmail } from '../../hooks';

import * as css from './BoothUserEmailConfirmationScreen.css';

type FormValues = {
    token: string;
    email: string;
};

export const BoothUserEmailConfirmationScreen = () => {
    const { register, handleSubmit } = useForm<FormValues>();
    const [params] = useSearchParams();
    const email = params.get('email') || '';

    const confirmEmail = useBoothUserConfirmEmail();
    const handleConfirmEmail = async (values: FormValues) => confirmEmail.mutate(values);
    const navigate = useNavigate();

    return (
        <Page>
            <Card>
                <Stack gap={u(2.5)} style={{ width: '350px' }}>
                    <Heading2>Check Your Email</Heading2>
                    <Text>
                        A confirmation code has been sent to <strong>{email}</strong>.
                    </Text>
                    <p>In order to verify your email address, please enter the code below.</p>
                    <Box>
                        <form onSubmit={handleSubmit(handleConfirmEmail)}>
                            <Stack gap={u(2.5)} style={{ width: '350px' }}>
                                {confirmEmail.error && (
                                    <span className={css.errorMessage}>{confirmEmail.error.message}</span>
                                )}
                                <input type="hidden" value={email} {...register('email')} />
                                <Input
                                    {...register('token')}
                                    required
                                    type="text"
                                    label="Verification code"
                                    placeholder="000000"
                                />
                                <Inline justifyContent="center">
                                    <Button type="button" variant="secondary" onClick={() => navigate('/')}>
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        isLoading={confirmEmail.isPending}
                                        isDisabled={confirmEmail.isPending}
                                        variant="primary"
                                    >
                                        Confirm
                                    </Button>
                                </Inline>
                            </Stack>
                        </form>
                    </Box>
                    <Stack gap={u(1)} py={u(2.5)} px={u(2)} className={css.notice}>
                        <Box display="flex" gap={u(1)} alignItems="center">
                            <Text variant="label">Didn’t receive the confirmation email?</Text>
                        </Box>
                        <Text variant="p">
                            If you haven’t received the confirmation email or the email has already been used, you can
                            confirm your email address by resetting your password.
                        </Text>
                    </Stack>
                </Stack>
            </Card>
        </Page>
    );
};
